import React from 'react';
import classNames from 'classnames';
import {labels} from '../../../../../util/utils';
import normalizeTeams from './normalizeTeams';
import StyledListView, {OutputTextMessage} from './StyledListView';
import StyledListViewGrid from './StyledListViewGrid';
import OutputText from '@ey/canvascoreservices/OutputText';
import Ellipsis from '../Ellipsis';
import TeamAccordion from './TeamAccordion';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import {IconoirEditPencil, IconoirEnlarge} from '@ey-xd/motif-icon';
import Button from '../../../../CoreWrappers/Button';
import {createProjectStepsIndex} from '../../../../../util/uiconstants';
import utilityfunctions from '../../../../../util/utilityfunctions';

import _ from 'lodash';
import Badge from '../../../../CoreWrappers/Badge';
import Dropdown from '../../../../CoreWrappers/Dropdown';
import styled from 'styled-components';

const ListView = ({components, handleEditIconClick, project, clientEngagements, projectOwners}) => {
	const nodes = normalizeTeams(components);
	const projectUsers = project.users;
	const renderHeader = () => {
		const textProps = {
			size: 'L',
			className: 'headers'
		};

		const propsBtnEdit = {
			svg: IconoirEditPencil,
			iconSize: 20,
			variant: 'text',
			title: labels.edit,
			onClick: () => handleEditIconClick(createProjectStepsIndex.createOrgChart)
		};
		return (
			<>
				<StyledListViewGrid className="data-headers">
					<OutputText body2 {...textProps}>
						<Ellipsis styleName="entity-header" content={labels.organizationalChartHeading} display="block" />
						<Badge value={components?.length} />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.admin} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.domainslabel} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.engagementsLabel} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.contacts} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.dashboardAccessFilter} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Ellipsis content={labels.columnContactList} display="block" />
					</OutputText>
					<OutputText body2 {...textProps}>
						<Button {...propsBtnEdit} />
					</OutputText>
				</StyledListViewGrid>
				<hr />
			</>
		);
	};
	const getRenderAdmin = (node) => {
		let admins = node.admins;
		let textToDisplay = labels.none;
		let countToDisplay = 0;
		let sortedAdmins = [];
		if (admins.length > 1) {
			sortedAdmins = utilityfunctions.sortListData(admins, 'firstName');
			textToDisplay = sortedAdmins[0].firstName + ' ' + sortedAdmins[0].lastName;
			countToDisplay = sortedAdmins.length - 1;
		} else {
			textToDisplay = admins.length > 0 ? admins[0].firstName + ' ' + admins[0].lastName : labels.none;
		}
		return (
			<>
				<Ellipsis content={textToDisplay} display="inline" />
				<>
					{countToDisplay > 0 && (
						<MotifTooltip
							id="tooltip-1"
							hideCloseButton={false}
							contentClassName="step4-tooltip"
							placement="bottom"
							allowClick={true}
							allowHover={false}
							trigger={
								<MotifButton variant="text-alt" aria-describedby="tooltip-1">
									{'+' + countToDisplay}
								</MotifButton>
							}
							closeButtonProps={{
								title: labels.modalCloseButton,
								'aria-label': labels.modalCloseButton
							}}
						>
							<StyledTooltipContent className={`${_.size(sortedAdmins) > 0 ? '' : 'default-msg'}`}>
								<section className="manage-tooltip-header">
									<h4 title={node.entityName} className="ellipsis">
										{node.entityName}
									</h4>
									{sortedAdmins.length && <Badge value={sortedAdmins.length} />}
								</section>
								<section className="main-wrap customScrollbar">
									<section className="tooltip-body ">
										{_.size(sortedAdmins) > 0 &&
											sortedAdmins.map((admin, index) => (
												<span
													className={'tooltipitem-info-name ellipsis'}
													key={index}
													title={admin.firstName + ' ' + admin.lastName}
												>
													{admin.firstName + ' ' + admin.lastName}
												</span>
											))}
									</section>
								</section>
							</StyledTooltipContent>
						</MotifTooltip>
					)}
				</>
			</>
		);
	};

	const getRenderDomain = (node) => {
		let domains = node.domains;
		let textToDisplay = labels.none;
		let countToDisplay = 0;
		let sortDomains = [];
		if (domains && domains.length > 1) {
			sortDomains = utilityfunctions.sortListData(domains);
			textToDisplay = sortDomains[0];
			countToDisplay = sortDomains.length - 1;
		} else {
			textToDisplay = domains && domains.length > 0 ? domains[0] : labels.none;
		}
		return (
			<>
				<Ellipsis content={textToDisplay} display="inline" />
				<>
					{countToDisplay > 0 && (
						<MotifTooltip
							id="tooltip-2"
							contentClassName="step4-tooltip"
							hideCloseButton={false}
							placement="bottom"
							allowClick={true}
							allowHover={false}
							trigger={
								<MotifButton variant="text-alt" aria-describedby="tooltip-2">
									{'+' + countToDisplay}
								</MotifButton>
							}
							closeButtonProps={{
								title: labels.modalCloseButton,
								'aria-label': labels.modalCloseButton
							}}
						>
							<StyledTooltipContent className={`${_.size(sortDomains) > 0 ? '' : 'default-msg'}`}>
								<section className="manage-tooltip-header">
									<h4 title={node.entityName} className="ellipsis">
										{node.entityName}
									</h4>
									{sortDomains.length && <Badge value={sortDomains.length} />}
								</section>
								<section className="main-wrap customScrollbar">
									<section className="tooltip-body ">
										{_.size(sortDomains) > 0 &&
											sortDomains.map((domain, index) => (
												<span className={'tooltipitem-info-name ellipsis'} key={index} title={domain}>
													{domain}
												</span>
											))}
									</section>
								</section>
							</StyledTooltipContent>
						</MotifTooltip>
					)}
				</>
			</>
		);
	};

	const getRenderEngagement = (node) => {
		let engagements = node.engagements;
		let textToDisplay = labels.none;
		let countToDisplay = 0;
		let sortengagements = [];
		if (engagements.length > 0) {
			if (clientEngagements) {
				const allClientEngagements = [...clientEngagements];

				let selectedEngagements = engagements?.map((engagementId) => {
					const selectedEngagement = allClientEngagements?.find(
						(engagement) => engagement.canvasEngagementId === engagementId
					);

					if (selectedEngagement === undefined) {
						return {canvasEngagementId: engagementId, engagementDescription: labels.notAvailable, notAvailable: true};
					}

					return selectedEngagement;
				});

				sortengagements = utilityfunctions.sortListData(selectedEngagements, 'engagementDescription');
			}
			textToDisplay = engagements.length;
			countToDisplay = engagements.length;
		} else {
			textToDisplay = labels.none;
		}

		const renderHeader = () => {
			return (
				<StyledHeader>
					<OutputText useTypography={false}>{node.entityName}</OutputText>
					<Badge value={sortengagements ? sortengagements.length : 0} />
				</StyledHeader>
			);
		};

		const renderTrigger = () => {
			return (
				<MotifButton variant="text-alt" aria-describedby="tooltip-2">
					{countToDisplay}
				</MotifButton>
			);
		};

		const renderItem = ({eng}) => {
			return eng?.notAvailable === true ? (
				<StyledBodyDropdown>
					<OutputText maxWidth="var(--px-550)" ellipsis title={eng.engagementDescription}>
						{eng.engagementDescription}
					</OutputText>
					<OutputText maxWidth="var(--px-550)" ellipsis title={eng.canvasEngagementId}>
						{eng.canvasEngagementId}
					</OutputText>
				</StyledBodyDropdown>
			) : (
				<StyledBodyDropdown>
					<StyledHeader>
						<OutputText maxWidth="var(--px-550)" ellipsis title={eng.engagementDescription}>
							{eng.engagementDescription}
						</OutputText>
						<OutputText maxWidth="var(--px-550)" ellipsis title={eng.idLabel + ' : ' + eng.canvasEngagementId}>
							{' '}
							- {labels.idLabel} : {eng.canvasEngagementId}
						</OutputText>
					</StyledHeader>
					<StyledHeader>
						<OutputText
							maxWidth="var(--px-550)"
							ellipsis
							title={eng.clientEngagementName + ' - ' + labels.codeLabel + ': ' + eng.clientEngagementCode}
						>
							{eng.clientEngagementName + ' - ' + labels.codeLabel + ': ' + eng.clientEngagementCode}
						</OutputText>
					</StyledHeader>
				</StyledBodyDropdown>
			);
		};

		const props = {
			placement: 'bottom-right',
			trigger: renderTrigger(),
			items: sortengagements.map((eng, index) => {
				return {
					id: eng.Id,
					type: 'container',
					customRender: renderItem,
					eng
				};
			}),
			topfix: true,
			reversed: true,
			maxItems: 3,
			itemSize: 52,
			header: renderHeader
		};

		return <>{countToDisplay > 0 ? <Dropdown {...props} /> : <Ellipsis content={textToDisplay} display="inline" />}</>;
	};
	const getRenderContacts = (node) => {
		let textToDisplay = labels.none;
		let countToDisplay = 0;
		let sortContacts = [];
		let admins = node.admins?.map((a) => {
			return {Id: a.userId, firstName: a.firstName, lastName: a.lastName};
		});
		let contacts = node.contacts?.map((a) => {
			return {Id: a.contactId, firstName: a.firstName, lastName: a.lastName};
		});
		let owners =
			node.pid === null || node.pid === undefined
				? projectOwners?.map((a) => {
						return {Id: a.userId, firstName: a.firstName, lastName: a.lastName};
				  })
				: [];
		let mergedAdminAndContacts = [...owners, ...admins, ...contacts];
		let uniqueUsers = _.uniqBy(mergedAdminAndContacts, 'Id');
		if (uniqueUsers?.length > 0) {
			sortContacts = _.sortBy(uniqueUsers, 'firstName');
			textToDisplay = sortContacts.length;
			countToDisplay = sortContacts.length;
		} else {
			textToDisplay = labels.none;
		}

		const renderHeader = () => {
			return (
				<StyledHeader>
					<OutputText useTypography={false}>{node.entityName}</OutputText>
					<Badge value={sortContacts ? sortContacts.length : 0} />
				</StyledHeader>
			);
		};

		const renderTrigger = () => {
			return (
				<MotifButton variant="text-alt" aria-describedby="tooltip-2">
					{countToDisplay}
				</MotifButton>
			);
		};

		const renderItem = ({contact}) => {
			return <OutputText useTypography={false}>{contact.firstName + ' ' + contact.lastName}</OutputText>;
		};

		const props = {
			placement: 'bottom-right',
			trigger: renderTrigger(),
			items: sortContacts.map((contact, index) => {
				return {
					id: contact.Id,
					type: 'container',
					customRender: renderItem,
					contact
				};
			}),
			topfix: true,
			reversed: true,
			maxItems: 3,
			itemSize: 52,
			header: renderHeader
		};

		return <>{countToDisplay > 0 ? <Dropdown {...props} /> : <Ellipsis content={textToDisplay} display="inline" />}</>;
	};
	const getRenderAccessToDashboard = (node) => {
		let projectOwnerIds =
			node.pid === null || node.pid === undefined
				? projectOwners.map((a) => {
						return a.userId;
				  })
				: [];
		let contactIds = node.contacts?.map((a) => {
			return a.contactId;
		});
		let usersIds = projectUsers?.map((a) => {
			return a.userId;
		});
		let matchedResultFromUser = contactIds.filter((x) => usersIds.includes(x));
		const adminsIds = node.admins?.map((a) => {
			return a.userId;
		});
		matchedResultFromUser = [...matchedResultFromUser, ...adminsIds];
		let accessToDashboards = [];
		matchedResultFromUser?.map((userId) => {
			const result = projectUsers?.find((x) => x.userId === userId);
			if (_.size(result) > 0) {
				if (_.size(result?.roles) === 0 || !result?.roles.every((a) => a === 'contacts view role')) {
					accessToDashboards.push(userId);
				}
			}
		});

		let mergedIds = [...projectOwnerIds, ...accessToDashboards];
		let uniqueUsers = _.uniqBy(mergedIds);
		let accessToDashboard = uniqueUsers.length;
		let textToDisplay = accessToDashboard > 0 ? accessToDashboard : labels.none;
		return (
			<>
				<Ellipsis content={textToDisplay} display="inline" />
			</>
		);
	};
	const getRenderAccessToContactList = (node) => {
		const adminsIds = node.admins?.map((a) => {
			return a.userId;
		});
		const usersIds = projectUsers?.map((a) => {
			return a.userId;
		});
		const contactIds = node.contacts?.map((a) => {
			return a.contactId;
		});
		const projectOwnerIds =
			node.pid === null || node.pid === undefined
				? projectOwners.map((a) => {
						return a.userId;
				  })
				: [];

		const combinedAdminIdsAndContactIds = _.uniqBy([...adminsIds, ...contactIds]);
		const matchedResultFromUser = combinedAdminIdsAndContactIds.filter((x) => usersIds?.includes(x));

		let accessToContact = [];
		matchedResultFromUser?.map((userId) => {
			const result = projectUsers?.find((x) => x.userId === userId);
			if (_.size(result?.roles) === 0 || result?.roles.includes('contacts view role')) {
				accessToContact.push(userId);
			}
		});
		const mergedIds = [...projectOwnerIds, ...accessToContact];
		const uniqueUsers = _.uniqBy(mergedIds);
		const accessToContactListCount = uniqueUsers.length;
		const textToDisplay = accessToContactListCount > 0 ? accessToContactListCount : labels.none;
		return (
			<>
				<Ellipsis content={textToDisplay} display="inline" />
			</>
		);
	};
	const renderContent = () => {
		const renderEntityName = ({node, textProps}) => (
			<OutputText {...textProps}>
				<Ellipsis content={node.entityName} display="block" />
			</OutputText>
		);
		const renderAdminsCount = ({node, textProps}) => <OutputText {...textProps}>{getRenderAdmin(node)}</OutputText>;
		const renderDomainsCount = ({node, textProps}) => <OutputText {...textProps}>{getRenderDomain(node)}</OutputText>;
		const renderEngagegmentsCount = ({node, textProps}) => (
			<OutputText {...textProps}>{getRenderEngagement(node)}</OutputText>
		);
		const renderContactsCount = ({node, textProps}) => (
			<OutputText {...textProps}>{getRenderContacts(node)}</OutputText>
		);
		const renderDashboardAccessFilterCount = ({node, textProps}) => (
			<OutputText {...textProps}>{getRenderAccessToDashboard(node)}</OutputText>
		);
		const renderContactListCount = ({node, textProps}) => (
			<OutputText {...textProps}>{getRenderAccessToContactList(node)}</OutputText>
		);
		const renderRow = (node) => {
			const textProps = {
				size: 'L'
			};
			const props = {node, textProps};

			return (
				<StyledListViewGrid className="team-data">
					{renderEntityName(props)}
					{renderAdminsCount(props)}
					{renderDomainsCount(props)}
					{renderEngagegmentsCount(props)}
					{renderContactsCount(props)}
					{renderDashboardAccessFilterCount(props)}
					{renderContactListCount(props)}
				</StyledListViewGrid>
			);
		};

		const renderEmpty = () => <OutputTextMessage size="L">{labels.noRecord}</OutputTextMessage>;
		const mapIt = (node, index) => {
			let children = null;
			if (node.children) children = <div className="team-children">{node.children?.map(mapIt)}</div>;
			return (
				<div className={classNames('team', {visible: node.visible, last: node.last})} key={index}>
					{node.pid === null || node.pid === undefined ? (
						<TeamAccordion header={renderRow(node)} children={children} />
					) : (
						<>
							{renderRow(node)}
							{children}
						</>
					)}
				</div>
			);
		};
		return (
			<>
				{!nodes.some(({visible}) => visible) && renderEmpty()}
				{nodes.map(mapIt)}
			</>
		);
	};

	return (
		<StyledListView>
			{renderHeader()}
			{renderContent()}
		</StyledListView>
	);
};

export default ListView;
const StyledTooltipContent = styled.section`
	width: 33rem;
	display: flex;
	flex-direction: column;
	min-height: 5rem;
	max-height: 20rem;
	.main-wrap {
		flex: 1;
		overflow: auto;
	}
	.tooltip-body {
		height: 100%;
		overflow: auto;
		width: 100%;
		color: ${(props) => props.theme.color['black']};
		background: ${(props) => props.theme.color['white']};
	}

	.header-text {
		background: ${(props) => props.theme.color['grey500']};
		font-size: 1.4rem;
		margin: 0;
		padding: 1.5rem 2rem;
		font-weight: bold;
		color: ${(props) => props.theme.color['white']};
	}

	.manage-tooltip-header {
		display: flex;
		align-items: center;
		border-bottom: 0.1rem solid ${(props) => props.theme.color['grey300']};
		padding: 1rem 3.3rem 1rem 1.5rem;
		background-color: ${(props) => props.theme.color['grey100']};
		color: ${(props) => props.theme.color['grey500']};
	}

	h4 {
		margin: 0;
		font-size: 1.4rem;
		max-width: 80%;
		margin-right: 1rem;
		.motif-badge {
			margin-left: 0.5rem;
			border-radius: 100rem;
			font-size: 1.2rem;
			padding: 0.2rem 0.4rem !important;
			background: ${(props) => props.theme.color['grey500']};
			color: ${(props) => props.theme.color['white']};
		}
	}
	&.default-msg {
		min-height: 12rem;
		.main {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.placeholder-message {
			padding: 1.5rem;
			font-size: 1.2rem;
			display: inline-block;
			width: 100%;
			text-align: center;
			font-weight: 300;
		}
	}

	.tooltipitem-info-name {
		display: flex !important;
		font-size: 1.2rem;
		padding: 1rem 3.3rem 1rem 1.5rem;
		width: 100%;
		font-weight: bold;
		&:last-child {
			padding-bottom: 1rem;
		}

		.eng-name {
			max-width: 18rem;
			margin-right: 0.5rem;
		}

		&.contact-names {
			display: inline-block !important;
		}
	}
	.tooltipitem-info-clientname {
		display: flex;
		font-size: 1.2rem;
		padding: 0 3.3rem 1rem 1.5rem;
		width: 100%;
		&:last-child {
			padding-bottom: 1rem;
		}
	}
	.hide {
		display: none;
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;

const StyledHeader = styled.div`
	display: flex;
	flex: 1;
	gap: var(--spacing-small);
	align-items: baseline;
	min-width: var(--px-600);
	.motif-button {
		margin-left: auto;
	}
`;

const StyledBodyDropdown = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;
